<template>
  <div v-if="showModal" class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex">
    <div class="relative p-8 bg-white w-full max-w-3xl m-auto flex-col flex rounded-lg shadow-lg">
      <h2 class="text-2xl font-bold mb-6">Create User</h2>

      <ErrorMessage v-if="showError" :message="errorMessage" :duration="5000"/>

      <form @submit.prevent="submitCreateUser" class="overflow-y-auto max-h-[70vh]">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">First Name</label>
          <input v-model="newUser.first_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Last Name</label>
          <input v-model="newUser.last_name" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Email</label>
          <input v-model="newUser.email" type="email" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Password</label>
          <input v-model="newUser.password" type="password" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Phone</label>
          <input v-model="newUser.phone" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Role</label>
          <select v-model="newUser.role" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required>
            <option value="user">User</option>
            <option value="talent">Talent</option>
            <option value="manager">Manager</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <!-- <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Date Created</label>
          <input v-model="newUser.date_created" type="date" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
        </div> -->
        <div class="flex justify-end">
          <button type="button" class="mr-4 py-2 px-4 bg-gray-500 text-white rounded" @click="closeModal">Cancel</button>
          <button type="submit" class="py-2 px-4 bg-blue-500 text-white rounded">Create User</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios'
import ErrorMessage from '../messages/ErrorMessage.vue';

export default {
  name: 'CreateUserModal',
  components: {
    ErrorMessage,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      newUser: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        phone: '',
        role: 'user',
        is_superuser: false,
        date_created: ''
      },
      showError: false,
      errorMessage: ''

    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async submitCreateUser() {
      this.showError = false;
      this.errorMessage = '';
      try {
        const response = await apiClient.post('/web/users', this.newUser)
        console.log('User created:', response.data.data)
        this.closeModal()
        this.$emit('refresh')
        this.$router.push({ name: 'UserDetails', params: { userId: response.data.user_id } })
      } catch (error) {
        if (error.response && error.response.status === 400) {
          if (error.response.data.message === 'Email already exists') {
            this.errorMessage = 'An account with this email address already exists.';
          } else {
            this.errorMessage = error.response.data.message || 'Error creating user'
          }
        } else {
          // General error handling for other status codes
          this.errorMessage = 'An unexpected error occurred while creating user.';
        }
        console.error('Error creating user:', error)
        this.showError = true;

      }
    }
  }
}
</script>

<style scoped>
.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
</style>

